import React from 'react';

import { InfoIcon } from 'assets/images';
import Tooltip from 'components/Tooltip';
import { Lender } from 'enums/ApplicationsVariables';
import { maskMonetaryValue } from 'utils/stringUtils';
import { LoanOfferIndicatorsText } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.constants';
import styles from 'pages/Dashboard/steps/AcceptOffer/ManualOffers/AcceptOneTermOffer/LoanOfferCard/LoanOfferCard.module.scss';
import { LoanOfferItem } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.types';
import { getTooltipTextForApr } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.utils';
import { Offer } from 'pages/Dashboard/steps/AcceptOffer/ManualOffers/AcceptOneTermOffer/LoanOfferCard/loanOfferCard.types';

export const getLoanOfferItems = (loanOffer: Offer, lender: string) => {
  const isQuiloLender = lender === Lender.Quilo;

  const details: LoanOfferItem[] = [
    {
      title: LoanOfferIndicatorsText.CashToYou,
      tooltipText: null,
      value: maskMonetaryValue(loanOffer.loanAmount),
    },
    {
      title: LoanOfferIndicatorsText.GrossLoan,
      tooltipText: 'This is your net loan plus applicable fees.',
      value: maskMonetaryValue(loanOffer.grossLoanAmount),
    },
    {
      title: LoanOfferIndicatorsText.FixedRate,
      tooltipText: null,
      value: <span className={isQuiloLender ? styles.fixRateValueAsterisk : ''}>{loanOffer.rate}%</span>,
    },
    {
      title: LoanOfferIndicatorsText.APR,
      tooltipText: getTooltipTextForApr({
        isProsperLender: loanOffer.lender === Lender.Prosper,
        rate: loanOffer.rate,
        oneTimeFeePercentage: loanOffer.oneTimeFeePercentage,
      }),
      value: `${loanOffer.apr}%`,
    },
    {
      title: LoanOfferIndicatorsText.TermYears,
      tooltipText: null,
      value: loanOffer.term,
    },
  ];

  return details;
};

interface LoanOfferCardProps {
  title: string;
  loanOffer: Offer;
  lender: string;
}

const LoanOfferCard = ({ title, loanOffer, lender }: LoanOfferCardProps) => {
  return (
    <div className={styles.loanOfferCard}>
      {title && <div className={styles.title}>{title}</div>}
      {getLoanOfferItems(loanOffer, lender).map((getLoanOfferItem) => (
        <div key={getLoanOfferItem.title} className={styles.loanInformationRow}>
          <div className={styles.titleWithTooltip}>
            <div>{getLoanOfferItem.title}</div>
            {getLoanOfferItem.tooltipText && (
              <Tooltip title={getLoanOfferItem.tooltipText}>
                <InfoIcon className={styles.iconInfo} />
              </Tooltip>
            )}
          </div>
          <div className={styles.optionsValue}>{getLoanOfferItem.value}</div>
        </div>
      ))}
      <div className={styles.monthlyPaymentContainer}>
        <div>{LoanOfferIndicatorsText.MonthlyPayment}</div>
        <div>{maskMonetaryValue(loanOffer.monthlyPayment?.toFixed(2))}</div>
      </div>
    </div>
  );
};

export default LoanOfferCard;
